/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';

interface GoogleMapReactProps {
  bootstrapURLKeys?: {
    key: string;
    libraries?: string[];
  };
  defaultZoom: number;
  center: {
    lat: number;
    lng: number;
  };
  onGoogleApiLoaded?: (map: any) => void;
  onBoundsChange?: () => void;
  onChange?: () => void;
  options?: any;
  yesIWantToUseGoogleMapApiInternals?: boolean;
  googleMapLoader?: (bootstrapURLKeys: any) => void;
}

const GoogleMapReact = dynamic<GoogleMapReactProps>(() =>
  import('google-map-react').then((x) => x as any)
);

export default GoogleMapReact;
